import { safeParse } from 'valibot'
import {
  EXPORT_DISK_PLACEHOLDER_ERROR,
  PublicStateMapDiskSchema,
  StateMapDisk,
  WORKSPACE_DISK_PLACEHOLDER_ERROR,
} from './state_map_disk.enum'

// Parses disks only from the public schema so dev-only placeholders stay rejected unless a trusted map page opts in.
export function ensureStateMapDisk(value?: string | null, fallback?: () => StateMapDisk): StateMapDisk {
  if (value == null || value === '') {
    if (fallback) {
      return fallback()
    }
    throw new Error('Missing state map disk')
  }

  const result = safeParse(PublicStateMapDiskSchema, value)
  if (!result.success) {
    throw new Error('Invalid disk: ' + value)
  }

  return result.output
}

// Guards against dev-only placeholders before falling back to the public parser.
export function ensureNonExportStateMapDisk(
  value?: string | null,
  fallback?: () => StateMapDisk,
  allowWorkspace = false
): StateMapDisk {
  if (value === StateMapDisk.Export) {
    throw new Error(EXPORT_DISK_PLACEHOLDER_ERROR)
  }
  if (value === StateMapDisk.Workspace && !allowWorkspace) {
    throw new Error(WORKSPACE_DISK_PLACEHOLDER_ERROR)
  }
  if (value === StateMapDisk.Workspace) {
    return StateMapDisk.Workspace
  }
  return ensureStateMapDisk(value, fallback)
}

export function getStateMapDiskFromLocalStorage(
  key: string,
  fallback: () => StateMapDisk,
  allowWorkspace = false
): StateMapDisk {
  if (typeof localStorage === 'undefined') {
    return fallback()
  }

  const raw = localStorage.getItem(key)
  if (!raw) {
    return fallback()
  }

  try {
    // Drop dev-only placeholders stored via localStorage unless the caller explicitly allows Workspace.
    return ensureNonExportStateMapDisk(raw, fallback, allowWorkspace)
  } catch (err) {
    console.warn(`Invalid disk stored in ${key}`, err)
    localStorage.removeItem(key)
    return fallback()
  }
}
